export enum ReportChangeHistoryType {
  EDIT,
  EMAIL
}
